import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const IndustryFilter = ({ selectedIndustry, setSelectedIndustry }) => {
  const industries = [
    {
      id: 'all',
      name: 'Tous les secteurs',
      icon: 'Grid3x3',
      color: 'text-blue-400',
      bgColor: 'bg-blue-500/10'
    },
    {
      id: 'mining',
      name: 'Mines & Ressources',
      icon: 'Mountain',
      color: 'text-amber-400',
      bgColor: 'bg-amber-500/10'
    },
    {
      id: 'finance',
      name: 'Finance & Banque',
      icon: 'Landmark',
      color: 'text-emerald-400',
      bgColor: 'bg-emerald-500/10'
    },
    {
      id: 'retail',
      name: 'Commerce',
      icon: 'ShoppingBag',
      color: 'text-blue-400',
      bgColor: 'bg-blue-500/10'
    },
    {
      id: 'manufacturing',
      name: 'Industrie',
      icon: 'Factory',
      color: 'text-slate-400',
      bgColor: 'bg-slate-500/10'
    },
    {
      id: 'services',
      name: 'Services Pro',
      icon: 'Briefcase',
      color: 'text-indigo-400',
      bgColor: 'bg-indigo-500/10'
    },
    {
      id: 'ngo',
      name: 'ONG',
      icon: 'Heart',
      color: 'text-rose-400',
      bgColor: 'bg-rose-500/10'
    }
  ];

  return (
    <div className="mb-6 md:mb-8">
      <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">Filtrer par secteur d'activité</h3>
      <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
        {industries?.map((industry, index) => (
          <motion.button
            key={industry?.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.05 }}
            onClick={() => setSelectedIndustry(industry?.id)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg border-2 transition-all flex-shrink-0 ${
              selectedIndustry === industry?.id
                ? `${industry?.bgColor} border-current ${industry?.color} font-semibold`
                : 'bg-slate-100 dark:bg-slate-800/60 border-slate-200 dark:border-white/10 text-slate-500 dark:text-slate-400 hover:border-blue-500/50'
            }`}
          >
            <Icon name={industry?.icon} size={18} />
            <span className="text-sm whitespace-nowrap">{industry?.name}</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default IndustryFilter;
